var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// Define foreground contexts (which should default to 'strong')
var foregroundContexts = ["text", "icon"];
export function createPaletteProxy(obj, path) {
    if (path === void 0) { path = []; }
    return new Proxy(obj, {
        get: function (target, prop) {
            // Handle regular property access - just pass through with recursive proxying
            if (prop in target) {
                var value = target[prop];
                if (typeof value === "object" && value !== null) {
                    // Recursively proxy nested objects, but don't add any toString methods
                    return createPaletteProxy(value, __spreadArray(__spreadArray([], path, true), [prop], false));
                }
                return value;
            }
            // Only handle explicit string conversion via String() constructor
            // String() uses valueOf/toString/Symbol.toPrimitive
            if (prop === Symbol.toPrimitive) {
                return function (hint) {
                    if (hint === "string") {
                        // Find default values using our priority logic
                        if ("default" in target) {
                            return target.default;
                        }
                        if ("strong" in target && "weak" in target) {
                            var isForeground = foregroundContexts.some(function (ctx) { return path.includes(ctx); });
                            return isForeground ? target.strong : target.weak;
                        }
                        // Try to find first leaf string value
                        for (var key in target) {
                            var val = target[key];
                            if (typeof val === "string") {
                                return val;
                            }
                        }
                    }
                    return Object(target);
                };
            }
            return undefined;
        },
    });
}
//# sourceMappingURL=palette-proxy.js.map